/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  TextField,
  Button,
  Box,
  IconButton,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { ThumbUp, ThumbDown, Close } from "@material-ui/icons";
import { apiGet, apiPost } from "../helpers/api";

// Components
import OfflineComponent from "../components/OfflineComponent";

const useStyles = makeStyles((theme) => ({
  grid: {
    "& .MuiBox-root > div": {
      justifyContent: "center",
    },
  },
  form: {
    marginTop: "20px",
    "& .MuiTextField-root": {
      width: "100% !important",
    },
  },
  toolbar: {
    margin: "0",
    top: "50%",
    transform: "translateY(-50%)",
  },
  appBar: {
    height: "10vh",
    backgroundColor: "#942424",
  },
  title: {
    flexGrow: 1,
    fontWeight: "bold",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#A3080C",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#bd0d12",
      borderColor: "#564345",
    },
  },
  rating: {
    display: "inline !important",
  },
  box: {
    marginTop: "20px",
    textAlign: "center",
  },
  icon: {
    padding: "20px",
  },
  alert: {
    width: "80%",
  },
}));

function Rate(props) {
  const classes = useStyles();

  const [done, setDone] = useState(false);
  const [delivery, setDelivery] = useState(null);
  const [rating, setRating] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");

  const submitHandler = async (e) => {
    e.preventDefault();

    if (rating > 0) {
      try {
        // send data to api endpoint
        const response = await apiPost(
          `/deliveries/${props.match.params.uuid}/rate`,
          {
            rating,
            remarks,
          }
        );

        if (response.data.data) {
          setDone(true);
        }
      } catch (err) {
        console.log(err.response?.data?.message);
      }
    } else {
      setError("Please select from the 2 options before submitting the form");
    }
  };

  if (!props.match.params.uuid) {
    // redirect if uuid is missing
    window.location.href = "/";
  }

  const fetchData = async () => {
    const response = await apiGet(`/deliveries/${props.match.params.uuid}/public`);
    setDelivery(response.data.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderAlreadyRated = () => (
    <div style={{ padding: "20px", display: "block" }}>
      <Box component="span" display="block">
        <Typography variant="h6" style={{ textAlign: "center" }}>
          This delivery has already been rated
        </Typography>
      </Box>
    </div>
  );

  const renderThankYouMessage = () => {
    return (
      <div style={{ padding: "20px", display: "block" }}>
        <Box component="span" display="block">
          <Typography variant="h6" style={{ textAlign: "center" }}>
            Thank you for ordering KFC
          </Typography>
        </Box>
        <Box component="span" display="block" style={{ marginTop: "20px" }}>
          <Typography
            variant="h6"
            style={{ textAlign: "center", fontSize: "small" }}
          >
            Served by a Hi-Flyer Food KFC Restaurant.
          </Typography>
        </Box>
      </div>
    );
  };

  const renderRatingForm = () => {
    return (
      <>
        <div style={{ padding: "20px", display: "block", width: "80%" }}>
          <Box component="span" display="block" className={classes.box}>
            Please rate your experience with us
          </Box>
          <Box component="span" display="block" className={classes.box}>
            <div className={classes.rating} onClick={() => setRating(1)}>
              <IconButton style={rating === 1 ? { color: "red" } : {}}>
                <ThumbDown fontSize="large" className={classes.icon} />
              </IconButton>
            </div>
            <div className={classes.rating} onClick={() => setRating(5)}>
              <IconButton style={rating === 5 ? { color: "red" } : {}}>
                <ThumbUp fontSize="large" className={classes.icon} />
              </IconButton>
            </div>
          </Box>
          <Box component="span" display="block" className={classes.box}>
            <form
              className={classes.form}
              noValidate
              autoComplete="off"
              onSubmit={submitHandler}
            >
              <TextField
                multiline
                rows={4}
                rowsMax={6}
                defaultValue=""
                variant="outlined"
                onChange={(e) => setRemarks(e.target.value)}
              />
              <Button
                type="submit"
                disableElevation
                variant="contained"
                fullWidth
                className={classes.submit}
              >
                Submit
              </Button>
            </form>
          </Box>
        </div>
      </>
    );
  };

  const renderContent = () => {
    if (!delivery) {
      return null;
    }

    if (delivery.rating) {
      return renderAlreadyRated();
    }

    if (done) {
      return renderThankYouMessage();
    }

    return renderRatingForm();
  };

  return (
    <>
      <OfflineComponent />
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" className={classes.title}>
            Rate us
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid
        container
        justify="center"
        style={{ marginTop: "100px" }}
        className={classes.grid}
      >
        {error !== "" && (
          <Alert
            className={classes.alert}
            severity="error"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  setError("");
                }}
              >
                <Close fontSize="inherit" />
              </IconButton>
            }
          >
            {error}
          </Alert>
        )}

        {renderContent()}
      </Grid>
    </>
  );
}

export default Rate;
